import React, { useState, useEffect } from 'react';
import { Box, Button, Stack, TextField, Typography } from '@mui/material';

import { exerciseOptions, fetchData } from '../utils/fetchData';
import HorizontalScrollbar from './HorizontalScrollbar'

const SearchExercises = ({ setExercises, bodyPart, setBodyPart }) => {
  const [search, setSearch] = useState('')
  
  const [bodyParts, setBodyParts] = useState([])

  useEffect(() => {
    const fetchExercisesData = async () => {
      const bodyPartsData = await fetchData('https://exercisedb.p.rapidapi.com/exercises/bodyPartList', exerciseOptions);

      setBodyParts(['all', ...bodyPartsData]);
    }

    fetchExercisesData();
  }, [])

  const handleSearch = async () => {
    if(search) {
      const exercisesData = await fetchData('https://exercisedb.p.rapidapi.com/exercises', exerciseOptions);

      const searchedExercises = exercisesData.filter(
        (exercise) => exercise.name.toLowerCase().includes(search) || 
        exercise.target.toLowerCase().includes(search) ||
        exercise.equipment.toLowerCase().includes(search) ||
        exercise.bodyPart.toLowerCase().includes(search)
      );

      setSearch('');
      setExercises(searchedExercises);
    }
  }

  return (
      <Stack alignItems="center" mt="37px" justifyContent="center" p="20px">
          <Box sx={{ position: 'relative', width: '100%', p: '40px',  m:'20px'}}>
              <HorizontalScrollbar data={bodyParts} bodyPart={bodyPart} setBodyPart={setBodyPart} isBodyParts/>
          </Box>

          <Typography
            fontWeight={700}
            sx={{ fontSize: { lg: '44px', xs: '30px' }}}
            mb="50px"
            textAlign="center"
          >
            Search Exercises
          </Typography>
          
          <Box position="relative" sx={{ border: 0 }}>
            <TextField
              sx={{
                input: { fontWeight: "700", border: 'none', borderColor: '#c9c9c9', borderRadius: '4px', color: '#fff', boxShadow: 
                '10px 10px 25px 10px #002121'},
                width: { lg: '1170px', xs: '350px' },
                backgroundColor: '#000',
                borderRadius: '5px',
              }}
              height="76px"
              value={search}
              onChange={(e) => setSearch(e.target.value.toLowerCase())}
              placeholder="Search Exercises"
              type="text"
            />
            <Button className='search-btn'
              variant="contained"
              sx={{
                bgcolor: '#FF2625',
                color: '#fff',
                textTransform: 'none',
                width: { lg: '175px', xs: '80px' },
                fontSize: { lg: '20px', xs: '14px' },
                height: '56px',
                position: "absolute",
                right: '0'
              }}
              onClick={handleSearch}
            >
              Search
            </Button>
          </Box>

      </Stack>
  )
}

export default SearchExercises